import React, { useEffect, useState } from "react";
import api from '../../services/api';
import { Link } from "react-router-dom";
import { StyledPartialSinistroTimeSheetsPage } from "../../styled-components/StyledPartialSinistroTimeSheetsPage.style";

export const PartialSinistroTimeSheets = ({ idTimesheet, isFromProjetoInterno }) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': false
        }
    };
    const [sinistroListaTs, setsinistroListaTs] = useState([]);
    const [totalHoras, setTotalHoras] = useState(0);
    const [totalValor, settotalValor] = useState(0);
    const [totalHorasProBono, setTotalHorasProBono] = useState(0);
    const [totalValorProBono, settotalValorProBono] = useState(0);
    
    const getSinistroTimeSheetsByIdTimesheet = async (idTimesheet) => {
        let listTs = null;
        try {
            const response = await api.get(`Timesheet/sinistro/${idTimesheet}/historico`, config);
            listTs = response.data.data;
        } catch (err) { }
        return listTs;
    }

    useEffect(() => {
        fetchData();
    }, [idTimesheet]);

    const fetchData = async () => {
        try {
            const tsSinistro = await getSinistroTimeSheetsByIdTimesheet(idTimesheet);
            
            if (tsSinistro?.length > 0) {
                setsinistroListaTs(tsSinistro);

                let totalHoras = 0;
                let totalValor = 0;
                let totalHorasProBono = 0;
                let totalValorProBono = 0;
                tsSinistro.forEach((tsItem) => {
                    totalHoras += tsItem.totalHorasFaturadas;
                    totalValor += tsItem.valorTotalFaturadoD;

                    totalHorasProBono += tsItem.horasProBono;
                    totalValorProBono += tsItem.valorProBonoD;
                });
                setTotalHorasProBono(totalHorasProBono)
                settotalValorProBono(totalValorProBono)
                setTotalHoras(totalHoras);
                settotalValor(totalValor);
            }
        } catch (error) {
            console.error('Erro:', error);
        }
    };

    const formatCurrency = (value) => {
        if (!value) {
            return 'R$ 0,00';
        }

        return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 });
    };

    const formatDecimal = (value) => {
        if (value == null || value === undefined || value === 0) {
            return '0,00';

        }
        return value.toLocaleString('pt-br', { style: 'decimal', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });

    };

    return (
        <div>
            {sinistroListaTs ? (
                <StyledPartialSinistroTimeSheetsPage >
                    <div className="card card-mobile-table" >
                        <div className="table-responsive">
                            <table className="table table-sm mb-0">
                                <thead>
                                    <tr className="table-light">
                                        <th colSpan={7}> Outros Timesheets relacionados ao Sinistro</th>
                                    </tr>
                                    <tr>
                                        <th scope="col" className="text-center">Sigla</th>
                                        <th scope="col" className="text-center">TimeSheet</th>
                                        <th scope="col" className="text-center">Status</th>
                                        <th scope="col" className="text-center">Etapa Aprovação</th>
                                        <th scope="col" className="text-center">Horas P.B</th>
                                        <th scope="col" className="text-center">Valor P.B</th>
                                        <th scope="col" className="text-center">Total Horas</th>
                                        <th scope="col" className="text-center">Valor Total</th>
                                        <th scope="col" className="text-center">Visualizar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {sinistroListaTs.map((tsItem) => {
                                        return (
                                            <tr className={tsItem.idTimesheet === idTimesheet ? "table-light" : ""}>
                                                <th scope="row" className="text-center">{tsItem.sigla}</th>
                                                <td className="text-center">{tsItem.timeSheetSigla}</td>
                                                <td className="text-center">{tsItem.statusTimeSheet}</td>
                                                <td className="text-center">{tsItem?.etapaAprovacao ?? '--'}</td>

                                                <td className="text-center">{formatDecimal(tsItem.horasProBono)}</td>
                                                <td className="text-center">{formatCurrency(tsItem.valorProBono)}</td>

                                                <td className="text-center">{formatDecimal(tsItem.totalHorasFaturadas)}</td>
                                                <td className="text-center">{formatCurrency(tsItem.valorTotalFaturado)}</td>
                                                <td className="text-center">
                                                    <Link target="_blank" className="menu-link" to={{ pathname: "/timesheetdetalhespage/", hash: tsItem.idTimesheet }}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5" />
                                                            <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z" />
                                                        </svg>
                                                    </Link>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                                <tfoot>
                                    <tr className="table-light ">
                                        <td className="text-center fw-bold" colSpan={4}>Total</td>
                                        <td className="text-center fw-bold" >{formatDecimal(totalHorasProBono)}</td>
                                        <td className="text-center fw-bold" >{formatCurrency(totalValorProBono)}</td>
                                        <td className="text-center fw-bold" >{formatDecimal(totalHoras)}</td>
                                        <td className="text-center fw-bold" >{formatCurrency(totalValor)}</td>
                                        <td className="text-center fw-bold" ></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </StyledPartialSinistroTimeSheetsPage>
            ) : (
                <span></span>
            )}
        </div>
    );

};
